﻿import React, {ComponentPropsWithoutRef} from 'react';
import {styled} from "@mui/system";
import {InputLabel, InputLabelOwnProps} from "@mui/material";

const Root = styled(InputLabel)(() => ({
  fontWeight: 400,
  fontFamily: 'Inter',
}));

type SortFilterInputLabelProps = InputLabelOwnProps & ComponentPropsWithoutRef<'label'>;

/**
 * Styled InputLabel for use with other form components
 * @param children passthrough children used for the Labels text
 * @param rest passthrough props to the internal Mui InputLabel
 * @constructor
 */
const SortFilterInputLabel = ({ children, ...rest}: SortFilterInputLabelProps) => {
  return <Root shrink={true} {...rest}>
    { children }
  </Root>
}

export { SortFilterInputLabel };
